export const github_modelsModels = {
    id: "github-models",
    name: "GitHub Models",
    api: "https://models.github.ai/inference",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://docs.github.com/en/github-models",
    env: ["GITHUB_TOKEN"],
    models: {
        "deepseek/deepseek-v3-0324": {
            id: "deepseek/deepseek-v3-0324",
            name: "DeepSeek-V3-0324",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2025-03-24",
            last_updated: "2025-03-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "deepseek/deepseek-r1-0528": {
            id: "deepseek/deepseek-r1-0528",
            name: "DeepSeek-R1-0528",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2025-05-28",
            last_updated: "2025-05-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 65536,
                output: 8192,
            },
        },
        "deepseek/deepseek-r1": {
            id: "deepseek/deepseek-r1",
            name: "DeepSeek-R1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2025-01-20",
            last_updated: "2025-01-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 65536,
                output: 8192,
            },
        },
        "meta/meta-llama-3-8b-instruct": {
            id: "meta/meta-llama-3-8b-instruct",
            name: "Meta-Llama-3-8B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-04-18",
            last_updated: "2024-04-18",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 2048,
            },
        },
        "meta/llama-3.2-90b-vision-instruct": {
            id: "meta/llama-3.2-90b-vision-instruct",
            name: "Llama-3.2-90B-Vision-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-09-25",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "meta/llama-3.3-70b-instruct": {
            id: "meta/llama-3.3-70b-instruct",
            name: "Llama-3.3-70B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "meta/meta-llama-3.1-70b-instruct": {
            id: "meta/meta-llama-3.1-70b-instruct",
            name: "Meta-Llama-3.1-70B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "meta/llama-4-maverick-17b-128e-instruct-fp8": {
            id: "meta/llama-4-maverick-17b-128e-instruct-fp8",
            name: "Llama 4 Maverick 17B 128E Instruct FP8",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2025-01-31",
            last_updated: "2025-01-31",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "meta/meta-llama-3.1-8b-instruct": {
            id: "meta/meta-llama-3.1-8b-instruct",
            name: "Meta-Llama-3.1-8B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "meta/meta-llama-3.1-405b-instruct": {
            id: "meta/meta-llama-3.1-405b-instruct",
            name: "Meta-Llama-3.1-405B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "meta/llama-3.2-11b-vision-instruct": {
            id: "meta/llama-3.2-11b-vision-instruct",
            name: "Llama-3.2-11B-Vision-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-09-25",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "meta/llama-4-scout-17b-16e-instruct": {
            id: "meta/llama-4-scout-17b-16e-instruct",
            name: "Llama 4 Scout 17B 16E Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2025-01-31",
            last_updated: "2025-01-31",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "meta/meta-llama-3-70b-instruct": {
            id: "meta/meta-llama-3-70b-instruct",
            name: "Meta-Llama-3-70B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-04-18",
            last_updated: "2024-04-18",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 2048,
            },
        },
        "xai/grok-3": {
            id: "xai/grok-3",
            name: "Grok 3",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-09",
            last_updated: "2024-12-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "xai/grok-3-mini": {
            id: "xai/grok-3-mini",
            name: "Grok 3 Mini",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-09",
            last_updated: "2024-12-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "openai/gpt-4.1": {
            id: "openai/gpt-4.1",
            name: "GPT-4.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/o1": {
            id: "openai/o1",
            name: "OpenAI o1",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2024-09-12",
            last_updated: "2024-12-17",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "openai/o3": {
            id: "openai/o3",
            name: "OpenAI o3",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2024-04",
            release_date: "2025-01-31",
            last_updated: "2025-01-31",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "openai/o1-preview": {
            id: "openai/o1-preview",
            name: "OpenAI o1-preview",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2024-09-12",
            last_updated: "2024-09-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "openai/gpt-4o-mini": {
            id: "openai/gpt-4o-mini",
            name: "GPT-4o mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-07-18",
            last_updated: "2024-07-18",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/gpt-4.1-nano": {
            id: "openai/gpt-4.1-nano",
            name: "GPT-4.1-nano",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/gpt-4.1-mini": {
            id: "openai/gpt-4.1-mini",
            name: "GPT-4.1-mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/o1-mini": {
            id: "openai/o1-mini",
            name: "OpenAI o1-mini",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2024-09-12",
            last_updated: "2024-12-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 65536,
            },
        },
        "openai/gpt-4o": {
            id: "openai/gpt-4o",
            name: "GPT-4o",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-05-13",
            last_updated: "2024-05-13",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/o4-mini": {
            id: "openai/o4-mini",
            name: "OpenAI o4-mini",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2024-04",
            release_date: "2025-01-31",
            last_updated: "2025-01-31",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "openai/o3-mini": {
            id: "openai/o3-mini",
            name: "OpenAI o3-mini",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2024-04",
            release_date: "2025-01-31",
            last_updated: "2025-01-31",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "ai21-labs/ai21-jamba-1.5-mini": {
            id: "ai21-labs/ai21-jamba-1.5-mini",
            name: "AI21 Jamba 1.5 Mini",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-08-29",
            last_updated: "2024-08-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 256000,
                output: 4096,
            },
        },
        "ai21-labs/ai21-jamba-1.5-large": {
            id: "ai21-labs/ai21-jamba-1.5-large",
            name: "AI21 Jamba 1.5 Large",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-08-29",
            last_updated: "2024-08-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 256000,
                output: 4096,
            },
        },
        "microsoft/phi-3-medium-4k-instruct": {
            id: "microsoft/phi-3-medium-4k-instruct",
            name: "Phi-3-medium instruct (4k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-04-23",
            last_updated: "2024-04-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 1024,
            },
        },
        "microsoft/phi-3.5-vision-instruct": {
            id: "microsoft/phi-3.5-vision-instruct",
            name: "Phi-3.5-vision instruct (128k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-08-20",
            last_updated: "2024-08-20",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-4-reasoning": {
            id: "microsoft/phi-4-reasoning",
            name: "Phi-4-Reasoning",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-4": {
            id: "microsoft/phi-4",
            name: "Phi-4",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 16000,
                output: 4096,
            },
        },
        "microsoft/phi-3-small-8k-instruct": {
            id: "microsoft/phi-3-small-8k-instruct",
            name: "Phi-3-small instruct (8k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-04-23",
            last_updated: "2024-04-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 2048,
            },
        },
        "microsoft/phi-4-mini-instruct": {
            id: "microsoft/phi-4-mini-instruct",
            name: "Phi-4-mini-instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-3-mini-128k-instruct": {
            id: "microsoft/phi-3-mini-128k-instruct",
            name: "Phi-3-mini instruct (128k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-04-23",
            last_updated: "2024-04-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-3-small-128k-instruct": {
            id: "microsoft/phi-3-small-128k-instruct",
            name: "Phi-3-small instruct (128k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-04-23",
            last_updated: "2024-04-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/mai-ds-r1": {
            id: "microsoft/mai-ds-r1",
            name: "MAI-DS-R1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2025-01-20",
            last_updated: "2025-01-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 65536,
                output: 8192,
            },
        },
        "microsoft/phi-3.5-moe-instruct": {
            id: "microsoft/phi-3.5-moe-instruct",
            name: "Phi-3.5-MoE instruct (128k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-08-20",
            last_updated: "2024-08-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-4-multimodal-instruct": {
            id: "microsoft/phi-4-multimodal-instruct",
            name: "Phi-4-multimodal-instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image", "audio"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-4-mini-reasoning": {
            id: "microsoft/phi-4-mini-reasoning",
            name: "Phi-4-mini-reasoning",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-3.5-mini-instruct": {
            id: "microsoft/phi-3.5-mini-instruct",
            name: "Phi-3.5-mini instruct (128k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-08-20",
            last_updated: "2024-08-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "microsoft/phi-3-mini-4k-instruct": {
            id: "microsoft/phi-3-mini-4k-instruct",
            name: "Phi-3-mini instruct (4k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-04-23",
            last_updated: "2024-04-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 4096,
                output: 1024,
            },
        },
        "microsoft/phi-3-medium-128k-instruct": {
            id: "microsoft/phi-3-medium-128k-instruct",
            name: "Phi-3-medium instruct (128k)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-04-23",
            last_updated: "2024-04-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "mistral-ai/mistral-small-2503": {
            id: "mistral-ai/mistral-small-2503",
            name: "Mistral Small 3.1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-09",
            release_date: "2025-03-01",
            last_updated: "2025-03-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "mistral-ai/mistral-large-2411": {
            id: "mistral-ai/mistral-large-2411",
            name: "Mistral Large 24.11",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-09",
            release_date: "2024-11-01",
            last_updated: "2024-11-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "mistral-ai/mistral-medium-2505": {
            id: "mistral-ai/mistral-medium-2505",
            name: "Mistral Medium 3 (25.05)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-09",
            release_date: "2025-05-01",
            last_updated: "2025-05-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "mistral-ai/ministral-3b": {
            id: "mistral-ai/ministral-3b",
            name: "Ministral 3B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "mistral-ai/mistral-nemo": {
            id: "mistral-ai/mistral-nemo",
            name: "Mistral Nemo",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-07-18",
            last_updated: "2024-07-18",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "mistral-ai/codestral-2501": {
            id: "mistral-ai/codestral-2501",
            name: "Codestral 25.01",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 32000,
                output: 8192,
            },
        },
        "cohere/cohere-command-r-08-2024": {
            id: "cohere/cohere-command-r-08-2024",
            name: "Cohere Command R 08-2024",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-08-01",
            last_updated: "2024-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "cohere/cohere-command-r-plus-08-2024": {
            id: "cohere/cohere-command-r-plus-08-2024",
            name: "Cohere Command R+ 08-2024",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-08-01",
            last_updated: "2024-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "cohere/cohere-command-a": {
            id: "cohere/cohere-command-a",
            name: "Cohere Command A",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-11-01",
            last_updated: "2024-11-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "cohere/cohere-command-r": {
            id: "cohere/cohere-command-r",
            name: "Cohere Command R",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-03-11",
            last_updated: "2024-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "cohere/cohere-command-r-plus": {
            id: "cohere/cohere-command-r-plus",
            name: "Cohere Command R+",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-03",
            release_date: "2024-04-04",
            last_updated: "2024-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "core42/jais-30b-chat": {
            id: "core42/jais-30b-chat",
            name: "JAIS 30b Chat",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-03",
            release_date: "2023-08-30",
            last_updated: "2023-08-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 8192,
                output: 2048,
            },
        },
    },
};
export default github_modelsModels;
//# sourceMappingURL=github-models.js.map